import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, ref } from "vue";
import _ from "underscore";
import * as monaco from "monaco-editor";
import EditorWorker from "monaco-editor/esm/vs/editor/editor.worker?worker";
import TsWorker from "monaco-editor/esm/vs/language/typescript/ts.worker?worker";
import JsonWorker from "monaco-editor/esm/vs/language/json/json.worker?worker";
import CssWorker from "monaco-editor/esm/vs/language/css/css.worker?worker";
import HtmlWorker from "monaco-editor/esm/vs/language/html/html.worker?worker";
import context from "./ctx";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CodeEditor',
    props: {
        className: {},
        contextType: {},
        value: {}
    },
    emits: ["transmitValue"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const CONTEXES = {
            prehandler: context.prehandlers,
        };
        let editor;
        const props = __props;
        const codeEditor = ref();
        const emit = __emit;
        const libraryUri = ref("");
        const setupEditor = () => {
            self.MonacoEnvironment = {
                getWorker(_, label) {
                    switch (label) {
                        case "typescript":
                        case "javascript":
                            return new TsWorker();
                        case "json":
                            return new JsonWorker();
                        case "css":
                            return new CssWorker();
                        case "html":
                        case "handlebars":
                        case "razor":
                            return new HtmlWorker();
                        default:
                            return new EditorWorker();
                    }
                },
            };
            monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
                noSemanticValidation: true,
                noSyntaxValidation: false,
            });
            monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
                target: monaco.languages.typescript.ScriptTarget.Latest,
                allowNonTsExtensions: true,
                isolatedModules: true,
            });
            const librarySource = CONTEXES[props.contextType];
            libraryUri.value = `ts:type${_.uniqueId(_.now().toString())}/context.d.ts`;
            monaco.languages.typescript.javascriptDefaults.addExtraLib(librarySource, libraryUri.value);
            // When resolving definitions and references, the editor will try to use created models.
            // Creating a model for the library allows "peek definition/references" commands to work with the library.
            monaco.editor.createModel(librarySource, "typescript", monaco.Uri.parse(libraryUri.value));
            editor = monaco.editor.create(codeEditor.value, {
                value: props.value,
                theme: "vs-dark",
                language: "typescript",
                fixedOverflowWidgets: true,
                automaticLayout: true,
            });
        };
        const getValue = () => {
            emit("transmitValue", editor === null || editor === void 0 ? void 0 : editor.getValue());
            return editor === null || editor === void 0 ? void 0 : editor.getValue();
        };
        onMounted(() => {
            setupEditor();
        });
        __expose({
            getValue,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["code-editor__wrapper", _ctx.className]),
                ref_key: "codeEditor",
                ref: codeEditor
            }, null, 2 /* CLASS */));
        };
    }
});
